import { KsService, useApiClient } from '@siclop/kstone-vue'
import type { ComponentPropertyType } from '../models'
import type { WireframeComponentProperty } from '../models'

export class ComponentPropertyTypeService extends KsService {
  protected static mainUrl = '/componentpropertytypes'

  /**
   * Get all property types
   */
  static async getAllPropertyTypes(): Promise<ComponentPropertyType[]> {
    const client = useApiClient()
    return await client.getAll<ComponentPropertyType>(this.mainUrl)
  }

  /**
   * Get property types by category
   */
  static async getByCategory(category: string): Promise<ComponentPropertyType[]> {
    const client = useApiClient()
    return await client.getAll<ComponentPropertyType>(`${this.mainUrl}/category/${encodeURIComponent(category)}`)
  }

  /**
   * Get property definitions for a component
   */
  static async getComponentProperties(componentId: number): Promise<WireframeComponentProperty[]> {
    const client = useApiClient()
    return await client.getAll<WireframeComponentProperty>(`/wireframecomponentproperties/component/${componentId}`)
  }
}
